import * as JSZip from 'jszip';

/**
 * Class used to represent and manage a zip file.
 */
export class ZipFile {
  /** Internal state of the zip file */
  private jszip = new JSZip();

  /**
   *
   * Add a file to the archive
   * @param path — Relative path to file
   * @param data — Content of the file
   * @param options — Optional information about the file
   */
  public addFile(path: string, data: Blob, options?: JSZip.JSZipFileOptions) {
    this.jszip.file(path, data, options);
  }

  /**
   * Returns the correspondent blob from the zip, if not empty.
   * If the zip is empty then an empty blob is returned.
   */
  public async getBlob() {
    if (Object.keys(this.jszip.files).length) {
      return await this.jszip.generateAsync({ type: 'blob' });
    }
    return new Blob();
  }
}
